import { HTTP } from '@/utils';
import { REQUEST } from '@/enum';
import { ApiPromise, ReferralBuilderPayloadInterface, ReferralBuilderProcessPayloadInterface } from '@/types';
import { useRequestCancel } from '@/composables/useRequestCancel';

export default class ReferralBuilderService {
  static resource = 'referral/builder';
  static requestCancel = useRequestCancel();

  static getReferralBuilderSettings(organizationId: number): ApiPromise {
    return HTTP.get(`${this.resource}/${organizationId}`, {
      ...this.requestCancel.requestSaverSetCancellation(REQUEST.REFERRAL_BUILDER),
    });
  }

  static createReferralBuilderSettings(payload: ReferralBuilderPayloadInterface): ApiPromise {
    return HTTP.post(`${this.resource}`, {
      ...payload,
      ...this.requestCancel.requestSaverSetCancellation(REQUEST.REFERRAL_BUILDER),
    });
  }

  static updateReferralBuilderSettings(
    payload: ReferralBuilderPayloadInterface,
    referralBuilderId: number,
  ): ApiPromise {
    return HTTP.post(`${this.resource}/${referralBuilderId}`, {
      ...payload,
      ...this.requestCancel.requestSaverSetCancellation(REQUEST.REFERRAL_BUILDER),
    });
  }

  static getReferralBuilderSettingsByCode(code: string): ApiPromise {
    return HTTP.get(`referral/settings?code=${code}`, {
      ...this.requestCancel.requestSaverSetCancellation(REQUEST.REFERRAL_BUILDER),
    });
  }

  static processReferralIntake(payload: ReferralBuilderProcessPayloadInterface): ApiPromise {
    return HTTP.post('referral/intake', { ...payload });
  }
}
